import { createSlice } from "@reduxjs/toolkit";
import {  IInbox } from "@/shared/services/interface/responses/IInboxResponses";
import { deleteInbox, getActivities, getInbox, getInfiniteInbox, markAsRead, toggleFavorite } from "../thunks/inboxThunk";
import { IBaseListResponse } from "@/shared/services/interface/responses/IBaseResponse";

interface IInboxState {
  inbox: IBaseListResponse<IInbox[]>;
  activities: IBaseListResponse<IInbox[]>;
  selectedInbox: IInbox | null;
  inboxLoading: boolean;
  activitiesLoading: boolean;
}

const initialState: IInboxState = {
  inboxLoading: false,
  activitiesLoading: false,
  selectedInbox: null,
  inbox: {
    data: [],
    totalCount: 0,
    page: 0,
    currentPage: 0,
    limit: 0,
    nextOffset: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
    success: false
  },
  activities: {
    data: [],
    totalCount: 0,
    page: 0,
    currentPage: 0,
    limit: 0,
    nextOffset: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
    success: false
  }
};

export const inboxSlice = createSlice({
  name: "inbox",
  initialState,
  reducers: {
    setInbox: (state, action) => {
      state.inbox = action.payload;
    },
    setActivities: (state, action) => {
      state.activities = action.payload;
    },
    setSelectedInbox: (state, action) => {
      state.selectedInbox = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInbox.pending, (state) => {
      state.inboxLoading = true;
    });
    builder.addCase(getInbox.fulfilled, (state, action) => {
      state.inbox = action.payload;
      state.inboxLoading = false;
    });
    builder.addCase(getInbox.rejected, (state) => {
      state.inboxLoading = false;
    });
    builder.addCase(getInfiniteInbox.pending, (state) => {
      state.inboxLoading = true;
    });
    builder.addCase(getInfiniteInbox.fulfilled, (state, action) => {
      state.inbox.data = [...state.inbox.data, ...action.payload.data];
      state.inboxLoading = false;
    });
    builder.addCase(getInfiniteInbox.rejected, (state) => {
      state.inboxLoading = false;
    });
    builder.addCase(markAsRead.pending, (state) => {
      state.inboxLoading = true;
    });
    builder.addCase(markAsRead.fulfilled, (state, action) => {
      state.inbox.data = state.inbox.data.map((inbox) =>
        inbox.id === action.payload.data.id ? { ...inbox, isRead: true } : inbox
      );
      state.inboxLoading = false;
    });
    builder.addCase(markAsRead.rejected, (state) => {
      state.inboxLoading = false;
    });
    builder.addCase(getActivities.pending, (state) => {
      state.activitiesLoading = true;
    });
    builder.addCase(getActivities.fulfilled, (state, action) => {
      state.activities = action.payload;
      state.activitiesLoading = false;
    });
    builder.addCase(getActivities.rejected, (state) => {
      state.activitiesLoading = false;
    });
    builder.addCase(toggleFavorite.pending, (state) => {
      state.inboxLoading = true;
    });
    builder.addCase(toggleFavorite.fulfilled, (state, action) => {
      state.inbox.data = state.inbox.data.map((inbox) =>
        inbox.id === action.payload.data.id ? { ...inbox, isFavorite: !inbox.isFavorite } : inbox
      );
      if(state.selectedInbox?.id === action.payload.data.id){
        state.selectedInbox = { ...state.selectedInbox, isFavorite: !state.selectedInbox.isFavorite };
      }
      state.inboxLoading = false;
    });
    builder.addCase(toggleFavorite.rejected, (state) => {
      state.inboxLoading = false;
    });
    builder.addCase(deleteInbox.pending, (state) => {
      state.inboxLoading = true;
    });
    builder.addCase(deleteInbox.fulfilled, (state) => {
      state.inboxLoading = false;
    });
    builder.addCase(deleteInbox.rejected, (state) => {
      state.inboxLoading = false;
    });
  }
});

export const { setInbox, setActivities, setSelectedInbox } = inboxSlice.actions;
export default inboxSlice.reducer;
